<script>
import {  mapGetters } from 'vuex'


export default {
    name: "educacionFormalPostulacion",
    data() {
        return {
            baseFormacion: {
                nombreDelCurso: null,
                institucionEducativa: null,
                endDate: null,
                horas: null,
                paisId: null,
                municipioId: null,
                departamentoId: null,
            },
            departamentos: [],
            municipios: []
        }
    },
    mounted() {
        if( !this.$store.getters.resumenFormacionNoFormal.length ) {
            this.agregarRegistro()
        }
    },
    computed: {
        ...mapGetters({
            listaPaises: 'getPaises',
            listaDepartamentos: 'getDepartamentos',
            listaMunicipios: 'getMunicipios',
            resumenFormacionNoFormal: 'resumenFormacionNoFormal'
        }),
    },
    methods: {
        assertData(idx) {
            console.log(this.$store.getters.resumenFormacionNoFormal[idx]);
        },
        agregarRegistro() {
            this.$store.commit('appendElement', { key: 'resumenFormacionNoFormal', newElement: this.baseExperiencia} )
        },
        eliminarRegistro(idx) {
            this.departamentos.splice(idx, 1)
            this.municipios.splice(idx, 1)
            this.$store.commit('deleteElementAt', { key: 'resumenFormacionNoFormal', idx})
        },
        saveAndContinue() {
            const inputs = document.querySelectorAll('input, select')
            try {
                inputs.forEach(input => {
                    if (!input.checkValidity()) {
                        input.reportValidity()
                        throw new Error('Formulario incompleto')
                    }
                })

                console.log(this.resumenFormacionNoFormal);

                let data = [
                    ...this.resumenFormacionNoFormal.map( formacion => {
                        formacion.PostulacionId = this.$store.getters.postulacionId
                        return formacion
                    })
                ]


                this.$store.getters.fetchPost({ path: 'Postulacion/EducacionNoFormal', data })
                .then( response => {
                    if( response.ok )
                    {
                        return response.json()
                    }
                    throw new Error("No se ha podido guardar educación formal")
                })
                .then( result => {
                    console.log(result);
                    this.$emit('nextStep')
                })
                .catch( error => console.log(error))

            } catch (error) {
                console.log(error);
                return
            }
        },
        setDepartamentosInElement( idx, paisId = null){
            this.$store.getters.fetchGet({ path: 'DepartamentoPais/ListByPais/' + paisId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.departamentos.length - 1) {
                        this.departamentos.push(data)
                    } else {
                        this.departamentos[idx] = data
                    }
                    this.departamentos = [...this.departamentos]
                })
                .catch(error => console.error(error))
        },
        setMunicipiosInElement( idx, departamentoId = null){
            this.$store.getters.fetchGet({ path: 'Municipio/ListByDepartamento/' + departamentoId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.municipios.length - 1) {
                        this.municipios.push(data)
                    } else {
                        this.municipios[idx] = data
                    }
                    this.municipios = [...this.municipios]
                })
                .catch(error => console.error(error))
        }
    }
}
</script>

<template>
    <div>

        <b-form @submit.prevent="assertData(idx)" v-for="(formacion, idx) in resumenFormacionNoFormal" :key="'formacion ' + idx">
            <b-row class="pb-1 px-3">
                <div class="d-flex align-items-center justify-content-between mt-2" style="width: 100%">
                    <p class="text-center my-0">
                        <b>
                            Ref. Educación no forma {{ idx + 1 }}
                        </b>
                    </p>
                    <div class="pointer btn btn-outline-danger m-1" @click="eliminarRegistro(idx)">
                        <i class="fas fa-solid fa-trash px-1"></i>Eliminar
                    </div>
                </div>
            </b-row>
            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNoFNombre" class="form-label">Nombre del curso</label>
                    <b-form-input v-model="formacion.nombreDelCurso" type="text" id="educacionNoFNombre" required/>
                </b-col>
                <b-col sm>
                    <label for="educacionNoFInstitucion" class="form-label">Institución educativa</label>
                    <b-form-input v-model="formacion.institucionEducativa" type="text" id="educacionNoFInstitucion" required/>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNoFTitulo" class="form-label">Título obtenido</label>
                    <b-form-input v-model="formacion.endDate" type="date" id="educacionNoFTitulo" required/>
                </b-col>
                <b-col sm>
                    <label for="educacionNoFHoras" class="form-label">Horas de duración</label>
                    <b-form-input v-model="formacion.horas" type="number" id="educacionNoFHoras" required/>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNoFPais" class="form-label">País</label>
                    <b-form-select required v-model="formacion.paisId" text-field="descripcion" value-field="id"
                        :options="listaPaises"
                        @change.native="setDepartamentosInElement( idx, formacion.paisId)"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm>
                    <label for="educacionNoFDepartamento" class="form-label">Departamento</label>
                    <b-form-select required v-model="formacion.departamentoId" text-field="descripcion" value-field="id"
                        :options="departamentos[idx]"
                        @change.native="setMunicipiosInElement( idx, formacion.departamentoId)"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            
            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNoFMunicipio" class="form-label">Municipio</label>
                    <b-form-select required v-model="formacion.municipioId" text-field="descripcion" value-field="id"
                        :options="municipios[idx]"
                        
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm></b-col>
            </b-row>

        </b-form>
        <div class="d-flex flex-row-reverse py-2" style="width: 100%; gap: 5px">
            <button class="btn px-4 py-2 btn-primary" @click="saveAndContinue">
                <span> Guardar y continuar </span>
            </button>
            <button class="btn px-4 py-2 btn-outline-success" @click="agregarRegistro">
                <span> Nuevo registro </span>
            </button>
        </div>
    </div>
</template>
